import { Component, OnInit, Input, OnChanges, SimpleChanges, HostListener, Inject, PLATFORM_ID } from "@angular/core";
import { DataService } from "../shared/common-services/data.service";
import { isPlatformBrowser } from "@angular/common";
declare let Swiper: any;

@Component({
  selector: 'app-part-type-slider',
  templateUrl: './part-type-slider.component.html',
  styleUrls: ['./part-type-slider.component.scss']
})

export class PartTypeSliderComponent implements OnInit, OnChanges{
  allProductsData = { loading: false, data: [], defaultPage: false, makeYearModelPage: false, selectedRepairIndex: 0, shopCategory: [], shopCategoryList: [], shopCategoryListShow: false, shopParttype: [], shopParttypeList: [], shopParttypeListShow: false, popularCategoryList: [], selectedPartType: [], defaultPartTypeList: [] };
  makeYearModelSession = { year_id: null, make_id: null, model_id: null, yearname: '', makename: '', modelname: '' };
  partsLoading = false;
  isPageBroswer = false;
  searchParts = [];
  displayData: boolean = true;
  isShowSliderImages: boolean = false;
  versionStatus: number = 0;
  slidersPartTypesData = [{"redirect_url":"https://autobuffy.com/part-type/brake-rotor","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/HobjBFyb3Sx3ijdMt88rcK6k/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Brake Rotor"},{"redirect_url":"https://autobuffy.com/part-type/headlight-assembly","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/GUxsSukqie8fh8wQCh3Ercvx/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Headlight"},{"redirect_url":"https://autobuffy.com/part-type/strut-and-coil-spring-assembly","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/YEhPSwxTLtXYTGMCZYAzpAjG/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Quick Strut"},{"redirect_url":"https://autobuffy.com/part-type/cv-axle-assembly","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/mysA2koVenmbxtFGbyzUSN8i/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"CV Axle"},{"redirect_url":"https://autobuffy.com/part-type/door-mirror","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/DMGA31oK6Ezf2jT8EwEvvEs8/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Mirror"},{"redirect_url":"https://autobuffy.com/part-type/wiper-blade","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/zHoArjxajp92SXvDT3XFDwJe/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Wiper"},{"redirect_url":"https://autobuffy.com/part-type/motor-oil","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/yTXD2dmWz1VJ58rghsSrYEbB/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Motor Oil"},{"redirect_url":"https://autobuffy.com/part-type/brake-pads","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/Er89xEBK5a4ALvPj9BmauEuD/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Brake Pads"},{"redirect_url":"https://autobuffy.com/part-type/wheel-bearing-hub-assembly","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/QwJnzBZxorJj7m8cNHpZTasV/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Wheel Hub"},{"redirect_url":"https://autobuffy.com/part-type/coil-spring-set","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/3am7R1VmtjFhK6QvyPsbVqYY/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Coil Spring"},{"redirect_url":"https://autobuffy.com/part-type/engine-motor-mount","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/6iKv5ZuhztadY1yFWuUmEaGH/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Motor Mount"},{"redirect_url":"https://autobuffy.com/part-type/ignition-coil","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/2nS3rBs5bBLM1wCcpvQ15nos/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Ignition Coil"},{"redirect_url":"https://autobuffy.com/part-type/tail-light","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/A8ywVMb9zy1g8gwgTLUuUXzm/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Tail Light"},{"redirect_url":"https://autobuffy.com/part-type/air-suspension-spring","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/XVgyS7VP6co6Dps5fjgdmW1M/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Air Spring"},{"redirect_url":"https://autobuffy.com/part-type/spark-plug","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/KxxwVH1R75kDyFznUVTAqnZg/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Spark Plug"},{"redirect_url":"https://autobuffy.com/part-type/shock-absorber","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/2P9HN9FupagCkuwhXZGRG4SF/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Shocks"},{"redirect_url":"https://autobuffy.com/part-type/belt-tensioner","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/pCa2zkVHWiGJvkPvxuet71a3/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Tensioner"},{"redirect_url":"https://autobuffy.com/part-type/steering-tie-rod-end","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/SdeCNdJGKH4NKzV5yyFspuqk/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Tie Rods"},{"redirect_url":"https://autobuffy.com/part-type/suspension-control-arm-and-ball-joint-assembly","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/9mwywFdBgjAG7Wb3Tc6zk7UN/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Control Arm"},{"redirect_url":"https://autobuffy.com/part-type/o2-oxygen-sensor","image_url":"https://ds31kih3xf8eg.cloudfront.net/variants/UbyzW55bA4CKBGXS166kWovP/4aed37fcc100f790c678f8cec7ca67943f00985660416438ba69b43eec774d28?format=webp","nick_name":"Oyxger Sensor"}];
  @Input() currentRoute: string = '';

  @HostListener('window:resize', ['$event'])
    onResize() {
      this.checkDeviceMode();
    }

  constructor(
    private sharedService: DataService,
    @Inject(PLATFORM_ID) private platformId: Object

  ){
    this.isPageBroswer = this.sharedService.getIsBrowser();
    this.sharedService.yearNamesAndIds.subscribe(res => {
      if(res){
        for (let i = 0, len = this.searchParts.length; i < len; ++i) {
          this.searchParts[i]['queryParams'] = {
            yearid: res.yearid, yearname: res.yearname,
            makeid: res.makeid, makename: res.makename,
            modelid: res.modelid, modelname: res.modelname,
            partname: this.searchParts[i].nick_name, parturl: this.searchParts[i]['redirect_url']
          }
        }
        this.allProductsData.makeYearModelPage = true;
      }
    })
  }

  partTypeClick(items): void {
    if (this.allProductsData.makeYearModelPage) {
      this.sharedService.setSearchLocalValues(
        { id: this.makeYearModelSession.year_id, year: this.makeYearModelSession.yearname },
        { id: this.makeYearModelSession.make_id, name: this.makeYearModelSession.makename },
        { id: this.makeYearModelSession.model_id, name: this.makeYearModelSession.modelname },
        items
      );
    }
  }

  ngOnChanges(changes: SimpleChanges) {
      this.handleChange()
  }

  handleChange(){
    if (this.currentRoute == '/' ) // display if always only home page
    {
      this.displayData = true;
    }
    else if (this.versionStatus == 0 && this.currentRoute != '/' ) // hide if mobile and not home page
    {
      this.displayData = false;
    }
    else if(this.versionStatus !== 0 && !this.currentRoute.includes('checkout')) // display if not mobile and not checkout page
    {
      this.displayData = true;
    }
    else{
      this.displayData = false;
    }

    if (this.displayData == true) // load data api if data is not loaded
    {
      this.loadData();
    }
  }

  ngOnInit(): void {
    this.checkDeviceMode();
  }

  loadData(){
    if(this.isPageBroswer){
      this.checkParts(this.slidersPartTypesData);
    }
  }

  redirectToPage(element): string {
    const a = document.createElement("a");
    a.href = element;
    return a['pathname'];
  }

  checkDeviceMode(): void {
    if (window.innerWidth < 748) {
      this.versionStatus = 0;  // Mobile
    } else if (window.innerWidth >= 748 && window.innerWidth <= 1024) {
      this.versionStatus = 1;  // Tablet
    } else {
      this.versionStatus = 2;   // Desktop
    }
  }

  checkParts(data?) {
    if (data) {
      this.setRedirectionUrl(data);
    } else {
      this.searchParts = [];
    }
  }

  setRedirectionUrl(array): void {
    let concatedarray = array;
    for (let i = 0, len = concatedarray.length; i < len; ++i) {
      concatedarray[i]['redirect_url'] = this.redirectToPage(concatedarray[i]['redirect_url']);
    }
    this.searchParts = concatedarray;
    this.addSliderDomEvents();
  }

  addSliderDomEvents (): void
  {
    if (isPlatformBrowser(this.platformId))
    { 
      let sliderSwipper = new Swiper(".slider-swipper", {
        speed: 1100,
        loop: false,
        loopFillGroupWithBlank: false,
        freeMode: true,
        navigation: {
          nextEl: ".swiper-button-next-slider",
          prevEl: ".swiper-button-prev-slider",
        },
        breakpoints: {
          0: {
            slidesPerView: 4,
            spaceBetween: 27,
          },
          768: {
            slidesPerView: 5,
            spaceBetween: 30,
            slidesPerGroup: 5,
          },
          1025: {
            slidesPerView: 13,
            spaceBetween: 40,
            slidesPerGroup: 10,
          },
          1600: {
            slidesPerView: 18,
            spaceBetween: 15,
            slidesPerGroup: 10,
          },
        },
      });
      this.isShowSliderImages = true;
      // this.partsLoading = false;
    }
  }


}